const splitOrderLines = (orderLines, orderLinesMax = 6) => {
  const forms1500Number = Math.ceil(orderLines.length / orderLinesMax);
  return [...new Array(forms1500Number)].map((item, index) => index)
    .reduce((accumulator, currentValue) => ([
      ...accumulator,
      orderLines.slice(
        currentValue * orderLinesMax,
        (currentValue * orderLinesMax) + orderLinesMax,
      ),
    ]), []);
};

export default splitOrderLines;



// WEBPACK FOOTER //
// ./src/utils/splitOrderLines.js